import { fetchApplicationAttachmentsV2 } from 'src/graphql/fetchApplicationAttachmentsV2.hirer.graphql';
import adCenterApiService from 'src/services/adCenterApiService';
import configurationService from 'src/services/configurationService';
import { sleep } from 'src/utils/sleep';

export type AddAttachmentServiceReturnType = Array<
  Awaited<ReturnType<typeof fetchApplicationAttachmentsV2>>[0] & {
    isNew?: boolean;
  }
>;

export const addAttachmentService = async ({
  jobId,
  applicationCorrelationId,
  prospectId,
  file,
}: {
  jobId: string;
  applicationCorrelationId: string;
  prospectId: string;
  file: File;
}): Promise<AddAttachmentServiceReturnType> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ID', prospectId);

  const newAttachmentId: number = await adCenterApiService.post(
    configurationService.getRelativeUrl(
      '/api/v2/prospectAttachment/saveProspectAttachment',
    ),
    formData,
    undefined,
    true,
  );

  // allow the attachment to be fully uploaded before fetching the list
  // otherwise graph would occasionally return error
  await sleep(1000);

  const attachments = await fetchApplicationAttachmentsV2({
    input: {
      applicationCorrelationId,
      jobId,
    },
  });

  return attachments.map((a) => ({
    ...a,
    isNew:
      typeof a.legacyAttachmentId === 'string' &&
      Number(a.legacyAttachmentId) === newAttachmentId,
  }));
};
